/**
 * Copyright (c) 2024-2026 ForgeRock. All rights reserved.
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */

export const JAVASCRIPT_SDK_TIMEOUT = 60 * 1000;
export const DATE_FORMAT_MMM_D_COMMA_YYYY = 'MMM D, YYYY';
